import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

import { getText, localizationService } from '../services/localization.js'

import classNames from 'classnames';

import styles from './AboutUs.module.css';

export const AboutUs = () => {
  return (
    <div>
      <Header />
      <div className='container'>
        <div className={styles.aboutWrapper}>
          <div className={styles.history}>
            <h3>{getText('نبذة عن تأسيس الشركة:', 'HISTORY:')}</h3>
            <div className={styles.historyText}>
              <p>{getText(
                `تأسست شركة ابو شقدم في عام 1996 وكانت من اوائل الشركات المتخصصة في 
                 صناعة المعادن والاشغال الحديدية وفي عام ٢٠٠٦
                 تم افتتاح المقر الجديد للشركة في
                 خلدا حيث طورت الشركة منتج جديد في ذلك الوقت في عالم الابواب وهو أبواب
                الامان المتعددة الاغلاق ولتلبية حاجة السوق المحلي من هذا النوع من الابواب تم بناء
                
                مصنع للشركة بمساحة
                4000
                متر مربع وتجهيزه باحدث االآلت والماكنات الصناعية الالمانية والتركية الصنع، واستقطاب
                العمالة الفنية المؤهلة حيث اصبح الكادر التشغيلي والاداري للشركة ما يقارب
                 ال٦٥ موضفاً
                 `,
                `Since its establishment in 1996 , Abu Shaqdam Brothers have been in the line of manufacturing
                special doors. In 2006 Tayseer Abu Shaqdam For Security Doors company has evolved as a
                leading specialized manufacturer for security doors with a new corporate identity and under a
                new name of Abu Shaqdam For Security Doors.” SD” , Focusing on the development , production
                and marketing of high quality security doors and indoors serving the local market.
                Abu Shaqdam For Security Doors Company . is located in its new facility in Amman – Marka On
                4000 Sq meters and opened its new head quarter in 2004 in Khalda .
                In addition to its sales team and top management , Abu Shaqdam For Security Doors employee
                around 65 skilled labours.`
              )}
              </p>
              <div className={styles.historyBg}></div>
            </div>
          </div>

          <div className={styles.objective}>
            <h3>{getText('الأهداف:', 'Objectives')}</h3>
            <p>{getText(`منذ تأسيس الشركة وهي تسعى الى صنع حاجات السوق المحلي من أبواب الامان
ذات الجودة العالية والجودة
الداخلية الخشب والمطابخ وغرف النوم وكافة أعمال الديكورات الداخلية.`, `The basic objectives of our company are to meet the needs of the Jordanian market of high
              quality – locally manufactured security doors under international standards as well as wooden
              works including ( indoors , kitchens , Decorations and Bed Rooms.`)}
            </p>
          </div>
          <div className={styles.development}>
            <div className={styles.developmentText}>
              <div className={classNames(styles.developmentBg, {
                [styles.developmentBgAr]: localizationService.currentLang$.value === 'AR',
              })}>
                <div className={classNames(styles.developmentBg2, {
                  [styles.developmentBg2Ar]: localizationService.currentLang$.value === 'AR',
                  })}>
                </div>
              </div>
              <p>
                <h3>{getText('التطوير والتحديث', 'Development & Innovation:')}</h3>
                {getText(`تم استحداث قسم التطوير والتحديث في الشركة وذلك لمتابعة آخر التحديثات العالمية
على منتجاتنا وكذلك تطوير نوعية المنتج والمواد الداخلة في التصنيع بالإضافة إلى قسم التصميم والمعني بتحديث التصاميم لمنتجاتنا باستمرار بما يلبي حاجات السوق و
خاصة الفلل والشقق الخاصة وكذلك المنشآت الحكومية والمستشفيات والبنوك .... الخ..`, `The company represented by its management and staff always cared about continuous
                improvements and keeping the product line up to date with technology. In addition to the
                security doors and their anti-breaking systems , we care about the beauty of the doors , So we
                create several decorations and colors for the cover wood exclusively by our design department
                to fit with the needs for villas , palaces , gates, and different kinds of buildings. Another
                department of indoors with several sizes , models. And colors that’s is well-taken care of has
                proved the perfect substitute for traditional wooden doors because of its one of a kind designs,
                solidness and high-quality manufacture under international standards.`)}
              </p>
            </div>
          </div>

          <div className={styles.objective}>
            <h3>{getText('خدمة ما بعد البيع:', 'After sales services:')}</h3>
            <p>{getText(`تم استحداث قسم الصيانة في الشركة والمعني بتقديم خدمة ما بعد البيع للعميل ومتابعة
أي مشاكل فنية قد تحدث بالموقع والعمل على إيجاد الحلول المناسبة لها سواء أثناء
التركيب او بعد ذلك.`, `Ever since the company was founded , one of its customer care objectives is to provide an
convenient after –sale service . A complete team of technicians and engineering specialists is set
for maintenance services as well as providing technical consultancy prior to installation .`)}
            </p>
          </div>

          <div className={styles.pp}>
            <div className={styles.products}>
              <h3>{getText('قائمة المنتجات', 'Products:')}</h3>
              <ul>
                <li>{getText('- ابواب أمان المتعددة الإغلاق', '- Security multi system lock doors.')}</li>
                <li>{getText('- ابواب خشب داخلية ', '- Wooden indoors.')}</li>
                <li>{getText('- اعمال حديدية ', '- Iron works.')}</li>
                <li>{getText('- مطابخ', '- Kitchens.')}</li>
                <li>{getText('- غرف نوم ', '- Bedrooms.')}</li>
                <li>{getText('- خزائن حائط', '- Walk in closet.')}</li>
                <li>{getText('- ديكورات داخلية', '- Decoration works.')}</li>
              </ul>
            </div>
            <div className={styles.projects}>
              <h3>{getText('المشاريع:', 'Projects:')}</h3>
              <p>
                {getText(`تمكنت الشركة من الحصول على مركز تنافسي في السوق الأردني في فترة قصيرة
                من الوقت . استقطبت العديد من الشركات الكبيرة في مختلف القطاعات بما في ذلك الإسكان والبنوك ،
                المكاتب الهندسية والسفارات والفنادق والجامعات والفيلات والشركات الخاصة الأخرى`, `The company was able to gain a competitive position in the Jordanian market in a short period
                of time . it attracted several large companies in different sectors including housing , banking ,
                engineering offices , embassies , hotels , universities , and other private villas & businesses.`)}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
